import { MessageCircle } from "lucide-react";
import { BRAND } from "@/lib/brand";

export default function WhatsAppFloat() {
  return (
    <a
      href={`https://wa.me/${BRAND.whatsapp}?text=Hi%20Invicta%20Overseas,%20I'd%20like%20free%20guidance%20to%20study%20abroad.`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 rounded-full bg-[#25D366] text-white pl-4 pr-5 py-3.5 font-bold shadow-2xl shadow-green-900/30 hover:scale-105 active:scale-95 transition-transform"
    >
      <MessageCircle className="w-6 h-6" />
      <span className="hidden sm:inline">Chat on WhatsApp</span>
    </a>
  );
}
